import { Injectable } from '@angular/core';
import { EmpresaService } from '../../modules/empresa/services/empresa.service';
import { RouteReuseStrategy, Router } from '@angular/router';
import { SucursalService } from '../../modules/sucursal/services/sucursal.service';
import { GrupoService } from '../../modules/grupo/services/grupo.service';
import { StorageService } from '@global-service/storage';

@Injectable()
export class StatusService {
  public grupo_id;
  public empresa_id;
  public sucursal_id;
  public proveedor_id;
  public routes: any[];
  public currentEmpresa: any;

  constructor(
    private readonly empresaService: EmpresaService,
    private readonly gruposService: GrupoService,
    private readonly router: Router,
    private readonly routeReuseStrategy: RouteReuseStrategy,
    private readonly sucursalService: SucursalService,
    private readonly storage: StorageService
  ) {
    this.routes = [];
    this.routeReuseStrategy.shouldReuseRoute = () => false; // Refrescar página cuando solo cambian los parámetros.
  }

  cambiarEstadoTienda(node: any) {
    this.currentEmpresa = node.data;
    const { grupo_id, empresa_id, sucursal_id, type, server_data, name, ambito_id } = node.data;
    switch (type) {
      case 'action':
        break;
      case 'grupo_empresas':
        this.gruposService.set(grupo_id);
        this.router.navigate(['/dashboard/grupo', grupo_id, 'mostrar']);
        break;
      case 'empresa_deipe':
        this.empresaService.set(grupo_id, empresa_id, server_data);
        this.storage.setEmpresa(empresa_id, name);
        this.storage.setGrupoId(grupo_id);
        this.storage.setAmbitoId(ambito_id);
        this.router.navigate(['/dashboard/grupo', grupo_id, 'empresa', empresa_id, 'mostrar']);
        break;
      case 'sucursal':
        this.empresaService.set(grupo_id, empresa_id, server_data);
        this.sucursalService.set(grupo_id, empresa_id, sucursal_id, server_data);
        // Nuevo desarrollo.
        this.storage.setEmpresa(empresa_id, name);
        this.storage.setGrupoId(grupo_id);
        this.storage.setSucursalId(sucursal_id);
        this.storage.setSociedadId(server_data.sociedad);
        // Accedemos desde el menu lateral izquierdo
        if(node.parent) {
          this.storage.setAmbitoId(node.parent.data.server_data.ambito_id ?? ambito_id);
        }
        this.router.navigate(['/dashboard/grupo', grupo_id, 'empresa', empresa_id, 'sucursal', sucursal_id, 'datos']);
        break;
    }
  }
}
